module.exports = __webpack_public_path__ + "static/media/bg.77ded1d5.svg";